import { render, staticRenderFns } from "./NewList4.vue?vue&type=template&id=72090c6e&scoped=true&"
import script from "./NewList4.vue?vue&type=script&lang=js&"
export * from "./NewList4.vue?vue&type=script&lang=js&"
import style0 from "./NewList4.vue?vue&type=style&index=0&id=72090c6e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72090c6e",
  null
  
)

export default component.exports